export class UWApprovalModalModel {
    id: number;
    description: string;
    status: string;
    uwComment: string;
    agentComment: string;
}
